'use client';
import * as React from 'react';
import { FabWrapper, FabContent } from './styles';
import { ButtonLabel } from '../../../styles';
import { ButtonProps } from '@mui/material';

interface Props extends ButtonProps {
    isExpanded?: boolean;
    label?: string;
    icon: React.ReactNode;
}

export const FloatingActionButton = ({
    label,
    isExpanded = false,
    icon,
    ...buttonProps
}: Props) => {
    return (
        <FabWrapper isExpanded={isExpanded} {...buttonProps}>
            <FabContent stretch>
                {icon}
                {isExpanded ? <ButtonLabel>{label}</ButtonLabel> : undefined}
            </FabContent>
        </FabWrapper>
    );
};
